import { render, staticRenderFns } from "./PackageOrder.vue?vue&type=template&id=9f79c238&scoped=true&"
import script from "./PackageOrder.vue?vue&type=script&lang=js&"
export * from "./PackageOrder.vue?vue&type=script&lang=js&"
import style0 from "./PackageOrder.vue?vue&type=style&index=0&id=9f79c238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f79c238",
  null
  
)

export default component.exports